<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <el-col :span="12">
            <h3>{{$t('pc.myaccount.shishi_bao')}} <span style="color:red;">{{$t('pc.myaccount.earn_money_with_stock_trading_annualized_return')}}{{annual_interest_rate}}%</span></h3>
          </el-col>
      </div>
      <el-tabs>
        <el-tab-pane id="isFromCoupon1">
          <h4 slot="label"> {{$t('pc.myaccount.shishi_bao')}}</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>{{$t('pc.myaccount.current_assets')}}</h3>
                  <p class="red">{{ amount }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>{{$t('pc.myaccount.past_8hour_return')}}</h3>
                  <p class="red">{{ interestthis }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>{{$t('pc.myaccount.cumulative_return')}}</h3>
                  <p class="red">{{ interestamount }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>{{$t('pc.myaccount.annualized_rate_return')}}</h3>
                  <p class="red">{{ annual_interest_rate }}%</p>
                </el-col>
                <el-col :span="12" style="text-align: right;padding-right:20px;">
                  <el-button type="danger" @click="moveInState = true;moveInAmount=cash">{{$t('pc.myaccount.transfer_in')}}</el-button>
                  <el-button type="primary" @click="moveOutState = true; moveOutAmount=timebao_accout">{{$t('pc.myaccount.transfer_out')}}</el-button>
                </el-col>
              </el-row>
            </div>
            <el-tabs stretch>
                <div style="text-align: left;padding-left: 20px;">
                    <img style="height: auto;width: 878px;" :src="timebaoImage">
                </div>
            </el-tabs>

          </el-card>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon2">
          <h4 slot="label">{{$t('pc.myaccount.bill')}}</h4>
          <el-card>
            <el-form :inline="true" size="mini">
            <el-form-item :label="$t('pc.trading.date')">
              <el-date-picker
                v-model="timebaoDetails.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('pc.myaccount.to')"
                :start-placeholder="$t('pc.myaccount.start_date')"
                :end-placeholder="$t('pc.myaccount.end_date')">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getTimebaoDetails">{{$t('pc.myaccount.search')}}</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="timebaoDetails.data"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              :label="$t('pc.allhkstock.name')">
            </el-table-column>
            <el-table-column
              prop="amount"
              align="center"
              :label="$t('pc.myaccount.funds')">
            </el-table-column>
            <el-table-column
              prop="balance"
              align="center"
              :label="$t('pc.trading.balance')">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              :label="$t('pc.trading.time')">
               <template slot-scope="scope">
                <p>{{ $getDeviceTime(scope.row.time) }}</p>
              </template>
            </el-table-column>
          </el-table>
          <div class="changePage" style="padding-top: 15px;">
            <el-button type="primary" icon="el-icon-arrow-left" @click="prevTimebao" size="mini">{{$t('pc.myaccount.previous_page')}}</el-button>
            <el-button type="primary" icon="el-icon-arrow-right" @click="nextTimebao" size="mini" style="float: right">
              {{$t('pc.myaccount.next_page')}}
            </el-button>
          </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog class="timebao_popup" :title="$t('pc.myaccount.transfer_to_shishibao')" :visible.sync="moveInState">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">{{$t('pc.myaccount.account_balance')}}:</h4>
          <p>{{ cash }}{{$t('pc.home.USD')}}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('pc.myaccount.transfer_in_amount')}}:</h4>
          <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="moveInAmount" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveInState = false">{{$t('pc.myaccount.cancel')}}</el-button>
        <el-button type="primary" @click="movein">{{$t('pc.myaccount.confirm')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog class="timebao_popup" :title="$t('pc.myaccount.transfer_from_shishibao')" :visible.sync="moveOutState">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">{{$t('pc.myaccount.available_balance')}}:</h4>
          <p>{{ timebao_accout }}{{$t('pc.home.USD')}}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">{{$t('pc.myaccount.cash_back')}}:</h4>
          <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="moveOutAmount" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveOutState = false">{{$t('pc.myaccount.transfer_out_amount')}}</el-button>
        <el-button type="primary" @click="moveout">{{$t('pc.myaccount.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "timebao",
      data(){
        return{
          amount:0,
          cash:0,
          timebao_accout:0,
          interestthis:0,
          interestamount:0,
          timebaoImage:"",
          moveInAmount:0,
          annual_interest_rate:0,
          moveOutAmount:null,
          moveInState:false,
          moveOutState:false,
          timebaoDetails: {
          date: [],
          data: [],
          page: 1,
          num: 20
        }
        }
      },
      computed:{
      },
      methods: {
       getTimebaoFund() {
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                nozzle: "timebao_fund",
                token: sessionStorage.getItem("token"),
                action: 'queryfund'
                }
            })
            .then(function (res) {
                if (res.data.code == 1) {
                let resData = res.data;
                that.account = resData.data.account;
                that.amount = resData.data.account.amount;
                that.interestthis = resData.data.account.interestthis;
                that.interestamount = resData.data.account.interestamount;
                that.timebaoImage = resData.data.image;
                that.annual_interest_rate = resData.data.annual_interest_rate;
                } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
                }
            });
      },
    getTimebaoDetails(){
        let that = this;
        let data = {
            nozzle: "timebao_fund",
              token: sessionStorage.getItem("token"),
              action: 'querylog',
              page: that.timebaoDetails.page,
              num:that.timebaoDetails.num,
            };
         if (that.timebaoDetails.date[0]) {
    data.start = that.$moment(that.timebaoDetails.date[0])
      .startOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
  if (that.timebaoDetails.date[1]) {
    data.end = that.$moment(that.timebaoDetails.date[1])
      .endOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
        that
          .$http({
            url: "/",
            method: "post",
            data: data
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.timebaoDetails.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(that.$t(res.data.msg)));
            }
          });
      },
      //获取用户信息
    getUserinfo() {
      let that = this;
      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "user",
          token: sessionStorage.getItem("token")
        }
      })
        .then(function (res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.moveInAmount= that.cash;
            that.timebao_accout = res.data.data.timebao_accout;
            that.moveOutAmount = that.timebao_accout;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(that.$t(res.data.msg)));
          }
        });
    },
      prevTimebao(){
          let page = this.timebaoDetails.page;
          if (page == 1){
            this.$message({
              message: this.$t('pc.timebao.first_page'),
              type: 'warning'
            });
          }else{
            this.timebaoDetails.page = page-1;
            this.getTimebaoDetails();
          }
        },
    nextTimebao(){
          let page = this.timebaoDetails.page;
          if ( this.timebaoDetails.data.length < 20){
            this.$message({
              message: this.$t('pc.timebao.last_page'),
              type: 'warning'
            });
          }else{
            this.timebaoDetails.page = page+1;
            this.getTimebaoDetails();
          }
        },
    movein(){
        let that = this;
        let money = that.moveInAmount;
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "timebao_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'movein',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.moveInState = false;
                  that.$message({
                    message: that.$t(that.$t(res.data.msg)),
                    type: 'success',
                    onClose:function () {
                      // that.mainMethod();
                    }
                  });
                  that.mainMethod();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(that.$t(res.data.msg)));
                }
              });
          
      },
    moveout(){
        let that = this;
        let money = that.moveOutAmount;
        that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "timebao_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'moveout',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.moveOutState = false;
                  that.$message({
                    message: that.$t(that.$t(res.data.msg)),
                    type: 'success',
                    onClose:function () {
                      // that.mainMethod();
                    }
                  });
                  that.mainMethod();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(that.$t(res.data.msg)));
                }
              });
      },
      mainMethod(){
        this.getTimebaoFund();
        this.getTimebaoDetails();
        this.getUserinfo();
      },
      },
      created() {
      },
      mounted () {
        this.getTimebaoFund();
        this.getTimebaoDetails();
        this.getUserinfo();
      },
      beforeDestroy() {
        
      },
    }
</script>

<style scoped>
</style>

<style>
.timebao_popup .el-dialog{
    width: 20% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Timebao.vue